export { globalSet } from './global/global';
export { Url, IUrl } from './url/url';
export { clone } from './clone/clone';
export { dashify } from './dashify/dashify';
export { destroyObject } from './destroy/destroy';
export { uid } from './uid/uid';
export { ScriptLoader } from './scriptloader/scriptloader';
export { Singleton } from './singleton/singleton';
export { setDateTime, checkBrowserLocaleTimezone, determineAppLanguage } from './prefHelpers/prefHelpers';



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/utils/index.ts